mutation SetReportingLabel(
    $computedDeliverableIdentifier: InputComputedDeliverableIdentifier!
    $campaignId: ID!
    $reportingLabel: String!
) {
    setComputedDeliverableCustomReportingLabel(
        computedDeliverableIdentifier: $computedDeliverableIdentifier
        campaignId: $campaignId
        reportingLabel: $reportingLabel
    ) {
        _id
        reportingLabel
        hash
    }
}
